import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import * as homeActions from '../home/redux/actions';
import KuposInput from '../common/KuposInput';
import KuposSelectBox from '../common/KuposSelectBox';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import CommonService from '../../services/commonService';
import { AppData } from '../../services';
import { KuposErrorSuccessModal } from '../common';

const features = [
  {
    icon: 'platform',
    title: 'PROFILE.INTUTIVE_PLATFORM',
    subtitle: 'PROFILE.INTUTIVE_PLATFORM_DETAIL.NORMAL',
    sub: 'PROFILE.INTUTIVE_PLATFORM_DETAIL.BOLD',
  },
  {
    icon: 'commision',
    title: 'PROFILE.IMMEDIATRE_COMISSION',
    subtitle: 'PROFILE.IMMEDIATRE_COMISSION_DETAIL.NORMAL',
    sub: 'PROFILE.IMMEDIATRE_COMISSION_DETAIL.BOLD',
  },
  {
    icon: 'bill',
    title: 'PROFILE.INVOICE_EMISSION',
    subtitle: 'PROFILE.INVOICE_EMISSION_DETAIL.NORMAL',
    sub: 'PROFILE.INVOICE_EMISSION_DETAIL.BOLD',
  },
];

class TravelAgency extends Component {
  static propTypes = {
    pages: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    t: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onChange = (val, type) => {
    switch (type) {
      case 'agency_rut':
        this.setState({ agencyRUT: CommonService.formatRut(val), agencyRUTError: null });
        break;
      case 'business_name':
        this.setState({ businessName: val, businessNameError: null });
        break;
      case 'agency_name':
        this.setState({ agencyName: val, agencyNameError: null });
        break;
      case 'address':
        this.setState({ address: val, addressError: null });
        break;
      case 'city':
        this.setState({ city: CommonService.onlyChars(val), cityError: null });
        break;
      case 'country':
        this.setState({ country: CommonService.onlyChars(val), countryError: null });
        break;
      case 'name':
        this.setState({ name: val, nameError: null });
        break;
      case 'last_name':
        this.setState({ lastName: val, lastNameError: null });
        break;
      case 'email':
        this.setState({ emailId: val, emailIdError: null });
        break;
      case 'phone':
        this.setState({ phone: CommonService.onlyNumbers(val), phoneError: null });
        break;
      case 'message':
        this.setState({ message: val, messageError: null });
        break;
      default:
        break;
    }
  };

  onBlur = (val, type) => {
    if (!val) {
      switch (type) {
        case 'agency_rut':
          this.setState({ agencyRUTError: { message: 'VALIDATIONS.INSERT_AGENCY_RUT' } });
          break;
        case 'business_name':
          this.setState({ businessNameError: { message: 'VALIDATIONS.INSERT_BUSINESS_NAME' } });
          break;
        case 'agency_name':
          this.setState({ agencyNameError: { message: 'VALIDATIONS.INSERT_AGENCY_NAME' } });
          break;
        case 'address':
          this.setState({ addressError: { message: 'VALIDATIONS.INSERT_ADDRESS' } });
          break;
        case 'city':
          this.setState({ cityError: { message: 'VALIDATIONS.SELECT_CITY' } });
          break;
        case 'country':
          this.setState({ countryError: { message: 'VALIDATIONS.SELECT_COUNTRY' } });
          break;
        case 'name':
          this.setState({ nameError: { message: 'VALIDATIONS.VALID_NAME' } });
          break;
        case 'last_name':
          this.setState({ lastNameError: { message: 'VALIDATIONS.VALID_SURNAME' } });
          break;
        case 'email':
          this.setState({ emailIdError: { message: 'VALIDATIONS.VALID_EMAIL' } });
          break;
        case 'phone':
          this.setState({ phoneError: { message: 'VALIDATIONS.VALID_MOBILE' } });
          break;
        // case 'message':
        //   this.setState({ message: val, messageError: null });
        //   break;
        default:
          break;
      }
    } else {
      if (type == 'email') {
        if (!CommonService.isEMailValid(val)) {
          this.setState({ emailIdError: { message: 'VALIDATIONS.VALID_EMAIL_VALIDATION' } });
        }
      }

      if (type == 'agency_rut') {
        if (!CommonService.isRutValid(val)) {
          this.setState({ agencyRUTError: { message: 'VALIDATIONS.VALID_RUT_VALID' } });
        }
      }
    }
  };

  validate = () => {
    let errors = 0;
    if (!this.state.agencyRUT) {
      this.setState({ agencyRUTError: { message: 'VALIDATIONS.INSERT_AGENCY_RUT' } });
      errors++;
    }

    if (!this.state.businessName) {
      this.setState({ businessNameError: { message: 'VALIDATIONS.INSERT_BUSINESS_NAME' } });
      errors++;
    }

    if (!this.state.agencyName) {
      this.setState({ agencyNameError: { message: 'VALIDATIONS.INSERT_AGENCY_NAME' } });
      errors++;
    }

    if (!this.state.address) {
      this.setState({ addressError: { message: 'VALIDATIONS.INSERT_ADDRESS' } });
      errors++;
    }

    if (!this.state.city) {
      this.setState({ cityError: { message: 'VALIDATIONS.SELECT_CITY' } });
      errors++;
    }

    if (!this.state.country) {
      this.setState({ countryError: { message: 'VALIDATIONS.SELECT_COUNTRY' } });
      errors++;
    }

    if (!this.state.name) {
      this.setState({ nameError: { message: 'VALIDATIONS.VALID_NAME' } });
      errors++;
    }

    if (!this.state.lastName) {
      this.setState({ lastNameError: { message: 'VALIDATIONS.VALID_SURNAME' } });
      errors++;
    }

    if (!this.state.emailId) {
      this.setState({ emailIdError: { message: 'VALIDATIONS.VALID_EMAIL' } });
      errors++;
    }
    if (!this.state.phone) {
      this.setState({ phoneError: { message: 'VALIDATIONS.VALID_MOBILE' } });
      errors++;
    }
    // if (!this.state.message) {
    //   this.setState({ messageError: { message: 'VALIDATIONS.INSERT_AGENCY_RUT' } });
    // }

    if (errors > 0) {
      return false;
    } else {
      return true;
    }
  };

  submitForm = () => {
    console.log('All bad and props are -------', this.props);
    if (!this.validate()) {
      return;
    }

    this.setState({ loading: true });

    console.log('All good and props are -------', this.props);

    let data = {
      agency_rut: this.state.agencyRUT,
      business_name: this.state.businessName,
      agency_name: this.state.agencyName,
      address: this.state.address,
      city: this.state.city,
      country: this.state.country,
      name: this.state.name,
      last_name: this.state.lastName,
      email: this.state.emailId,
      phone_number: this.state.phone,
      message: this.state.message,
    };

    this.props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/travel_agent_query',
        type: 'home',
        data: data,
        method: 'POST',
      })
      .then(
        res => this.onFormSubmit(res),
        err => this.onFormSubmit(err),
      );
  };

  onFormSubmit = result => {
    console.log('result from farm submit --------', result);

    this.setState({ loading: false });

    if (result && result.data && result.data.status === 'Success') {
      this.setState({
        showModal: true,
        showModalStatus: true,
        showModalMessage: 'TRANSLATIONS.TRAVEL_AGENCY_SUCCESS',
      });
    }
  };

  onButtonSubmitSuccess = () => {
    this.setState({ showModal: false });

    if (this.state.showModalStatus) {
      this.props.history.push('/');
    }

    // this.state.showModalStatus ? this.props.hisory.push('/') : null;
  };

  render() {
    const { t } = this.props;
    console.log('State is', this.state);
    return (
      <div className="investors-default-page pages-travel-agency">
        <div className="home-banner" style={{ marginBottom: 50 }}>
          <img src="/static/images/icons/agency/agency-banner.png" alt="home-banner" />
        </div>
        <div className="page-title font20 white-text">
          {i18next.language == 'es' ? (
            <span>
              Agencias<span className="bold-text">&nbsp;de Viajes</span> <br />
              <span className="font10">
                Una solucion para agencias de viaje y turismo que permite cotizar y comprar pasajes
                de bus en tiempo real
              </span>
            </span>
          ) : (
            <span>
              Travel<span className="bold-text">&nbsp;Agency</span> <br />
              <span className="font10">
                A solution for travel and tourism agencies that allows you to quote and buy bus
                tickets in real time
              </span>
            </span>
          )}
        </div>
        <div className="content-container cancel-done-section">
          <div className="center-text font20">
            {this.props.t('PROFILE.REGISTER_AS_AGENCY.NORMAL')}
            <span className="bold-text">
              &nbsp;{this.props.t('PROFILE.REGISTER_AS_AGENCY.BOLD')}
            </span>
          </div>
          <div className="flex-row center-text space-between" style={{ marginTop: 60 }}>
            {features.map((val, key) => (
              <div className="" key={key}>
                <img src={'/static/images/icons/agency/' + val.icon + '.svg'} alt={val.title} />
                <div>
                  <div>&nbsp;</div>
                  <span className="bold-text font11">{this.props.t(val.title)}</span> <br />
                  <span className="font10">{this.props.t(val.subtitle)}</span> <br />
                  <span className="font10">{this.props.t(val.sub)}</span>
                </div>
              </div>
            ))}
          </div>
          <div
            className="kupos-card contact-us-item font10 agency-form"
            style={{ margin: '70px 0' }}
          >
            <div className="passenger-inputs-block">
              <span className="bold font12">{this.props.t('PROFILE.CONTACT_DETAILS')}</span>
            </div>
            <table className="passenger-input-personal-details">
              <tbody>
                <div>
                  <tr className="passenger-input-heading font10 travel-agency-input-container">
                    <th className="rut-input">{this.props.t('PROFILE.AGENCY_RUT')}</th>
                    <th className="rut-input">{this.props.t('PROFILE.BUSSINESS_NAME')}</th>
                    <th className="agencia-input">{this.props.t('PROFILE.AGENCY_NAME')}</th>
                  </tr>
                </div>

                <div>
                  <tr className="passenger-input font10 travel-agency-input-container">
                    <td className="rut-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        onChange={val => this.onChange(val, 'agency_rut')}
                        onBlur={val => this.onBlur(val, 'agency_rut')}
                        placeholder="xxxxx-x"
                        value={this.state.agencyRUT}
                        error={this.state.agencyRUTError ? true : false}
                        errorMessage={
                          this.state.agencyRUTError ? this.state.agencyRUTError.message : null
                        }
                      />
                    </td>
                    <td className="rut-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        placeholder="xxxxx-x"
                        onChange={val => this.onChange(val, 'business_name')}
                        onBlur={val => this.onBlur(val, 'business_name')}
                        error={this.state.businessNameError ? true : false}
                        errorMessage={
                          this.state.businessNameError ? this.state.businessNameError.message : null
                        }
                      />
                    </td>
                    <td className="agencia-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        onChange={val => this.onChange(val, 'agency_name')}
                        onBlur={val => this.onBlur(val, 'agency_name')}
                        placeholder="Agencia"
                        error={this.state.agencyNameError ? true : false}
                        errorMessage={
                          this.state.agencyNameError ? this.state.agencyNameError.message : null
                        }
                      />
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
            <table className="passenger-input-personal-details">
              <tbody>
                <div>
                  <tr className="passenger-input-heading font10 travel-agency-input-container">
                    <th className="rut-input">{this.props.t('PROFILE.ADDRESS')}</th>
                    <th className="rut-input">{this.props.t('PROFILE.CITY')}</th>
                    <th className="agencia-input">{this.props.t('PROFILE.COUNTRY')}</th>
                  </tr>
                </div>

                <div>
                  <tr className="passenger-input font10 travel-agency-input-container">
                    <td className="rut-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        placeholder="xxxxx-x"
                        onChange={val => this.onChange(val, 'address')}
                        onBlur={val => this.onBlur(val, 'address')}
                        error={this.state.addressError ? true : false}
                        errorMessage={
                          this.state.addressError ? this.state.addressError.message : null
                        }
                      />
                    </td>
                    <td className="rut-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        placeholder="xxxxx-x"
                        onChange={val => this.onChange(val, 'city')}
                        value={this.state.city}
                        onBlur={val => this.onBlur(val, 'city')}
                        error={this.state.cityError ? true : false}
                        errorMessage={this.state.cityError ? this.state.cityError.message : null}
                        // pattern={'chars'}
                      />
                    </td>
                    <td className="agencia-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        placeholder="xxxxx-x"
                        value={this.state.country}
                        onChange={val => this.onChange(val, 'country')}
                        onBlur={val => this.onBlur(val, 'country')}
                        error={this.state.countryError ? true : false}
                        errorMessage={
                          this.state.countryError ? this.state.countryError.message : null
                        }
                      />
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
            <hr />
            <div className="passenger-inputs-block">
              <span className="bold font12">{this.props.t('PROFILE.CONTACT_DETAILS')}</span>
            </div>
            <table className="passenger-input-personal-details">
              <tbody>
                <div>
                  <tr className="passenger-input-heading font10 travel-agency-input-container-four">
                    <th className="personal-input">{this.props.t('HOME.NAME')}</th>
                    <th className="personal-input">{this.props.t('HOME.LAST_NAME')}</th>
                    <th className="personal-input">{this.props.t('HOME.EMAIL_ID')}</th>
                    <th className="personal-input">{this.props.t('HOME.PHONE_NUMBER')}</th>
                  </tr>
                </div>

                <div>
                  <tr className="passenger-input font10 travel-agency-input-container-four">
                    <td className="personal-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        onChange={val => this.onChange(val, 'name')}
                        onBlur={val => this.onBlur(val, 'name')}
                        error={this.state.nameError ? true : false}
                        errorMessage={this.state.nameError ? this.state.nameError.message : null}
                        // placeholder='xxxxx-x'
                      />
                    </td>
                    <td className="personal-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        onChange={val => this.onChange(val, 'last_name')}
                        onBlur={val => this.onBlur(val, 'last_name')}
                        error={this.state.lastNameError ? true : false}
                        errorMessage={
                          this.state.lastNameError ? this.state.lastNameError.message : null
                        }
                        // placeholder='xxxxx-x'
                      />
                    </td>
                    <td className="personal-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        onChange={val => this.onChange(val, 'email')}
                        onBlur={val => this.onBlur(val, 'email')}
                        error={this.state.emailIdError ? true : false}
                        errorMessage={
                          this.state.emailIdError ? this.state.emailIdError.message : null
                        }
                        // placeholder='xxxxx-x'
                      />
                    </td>
                    <td className="personal-input">
                      <KuposInput
                        className="kupos-border"
                        type="text"
                        value={this.state.phone}
                        onChange={val => this.onChange(val, 'phone')}
                        onBlur={val => this.onBlur(val, 'phone')}
                        error={this.state.phoneError ? true : false}
                        errorMessage={this.state.phoneError ? this.state.phoneError.message : null}
                        // placeholder='xxxxx-x'
                      />
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
            <table className="passenger-input-personal-details">
              <tbody>
                <tr className="passenger-input-heading font10">
                  <th className="personal-input">{this.props.t('PROFILE.MESSAGE')}</th>
                </tr>
                <tr>
                  <td className="personal-input">
                    <KuposInput
                      className="kupos-border"
                      type="text"
                      t={t}
                      placeholder={'HOME.OPTIONAL'}
                      onChange={val => this.onChange(val, 'message')}
                      onBlur={val => this.onBlur(val, 'message')}
                      error={this.state.messageError ? true : false}
                      errorMessage={
                        this.state.messageError ? this.state.messageError.message : null
                      }
                      // placeholder='xxxxx-x'
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="flex-row pay-now-section font13" style={{ justifyContent: 'center' }}>
              <button onClick={this.submitForm} className="pay-now-button kupos-button" disabled="">
                {this.state.loading ? (
                  <div className="loader-cricle"></div>
                ) : (
                  <span>{this.props.t('PROFILE.SEND_REQUEST')}</span>
                )}
              </button>
            </div>
          </div>
        </div>

        <KuposErrorSuccessModal
          showModal={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          onButtonClick={() => this.onButtonSubmitSuccess()}
          success={this.state.showModalStatus}
          // title="PROFILE.ALMOST_READY"
          subTitle={this.props.t(this.state.showModalMessage)}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions, ...commonActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(TravelAgency));



// WEBPACK FOOTER //
// ./src/features/pages/TravelAgency.js